interface Props {
  [key: string]: string;
}

function checkFormFieldsFilled(values: Props) {
  return Object.values(values).every((value) => value.length > 0);
}

export default checkFormFieldsFilled;
